import cx from 'classnames';
import React, { useEffect, useState } from 'react';
import { DatePicker } from '@arco-design/web-react';
import styles from './datepicker.module.css';
import { convertDateFromIsoToHTMLFormat } from '../utils/date';

export const DateTimePicker = ({ className, error, showTime, value, onChange = () => {} }) => {
  const handleDateSelection = (value) => {
    onChange(value);
  };

  return (
    <div>
      <DatePicker
        className={cx(styles.datetimepicker, className)}
        showTime={showTime}
        allowClear
        format="MMMM DD, YYYY h:mm a"
        value={value}
        onChange={handleDateSelection}
      />
      <span className={styles.error}>{error}</span>
    </div>
  );
};

export const DateRangePicker = ({ onChange = () => {}, className, clear_date, initial_value }) => {
  const [display_value, setDisplayValue] = useState([]);

  useEffect(() => {
    if (!initial_value || !Array.isArray(initial_value) || initial_value.length !== 2) return;
    const [start, end] = initial_value;
    const range_start = convertDateFromIsoToHTMLFormat(start);
    const range_end = convertDateFromIsoToHTMLFormat(end);
    if (!range_start || !range_end) return;

    setDisplayValue([range_start, range_end]);
  }, [initial_value]);

  useEffect(() => {
    if (clear_date) {
      setDisplayValue([]);
    }
  }, [clear_date]);

  const handleChange = (val) => {
    setDisplayValue(val);
    onChange(val);
  };

  return (
    <DatePicker.RangePicker
      className={cx(styles.datepicker, className)}
      onChange={handleChange}
      value={display_value}
      allowClear
    />
  );
};
